import i18next from "i18next";

import { createColumn } from "../../../../components/Table";

export const worflowsListColumns = [
  createColumn({
    keyName: "title",
    header: () => i18next.t("workflows_columns_title"),
    cell: (info) => info.renderValue(),
    size: 200,
  }),
  createColumn({
    keyName: "description",
    header: () => i18next.t("workflows_columns_description"),
    cell: (info) => info.renderValue(),
    size: 200,
  }),
  createColumn({
    keyName: "updated",
    header: () => i18next.t("workflows_columns_lastEdited"),
    cell: (info) => info.renderValue(),
  }),
  createColumn({
    keyName: "published",
    header: () => i18next.t("workflows_columns_published"),
    cell: (info) => info.renderValue(),
    size: 50,
  }),
  createColumn({
    keyName: "action",
    header: () => "",
    cell: (info) => info.renderValue(),
    size: 50,
  }),
];
